import React, { useState } from "react";
import "../Educator/eduSignIn.css";
import "../Educator/eduSignUp.css";
import {
	// Avatar,
	Button,
	// Paper,
	Grid,
	// Typography,
	Container,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
// import Joi from "joi-browser";
//import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
//import { signUp, studentSignupWithGoogle } from "../../services/api";
import useStyles from "../StudentAuth/styles";
import Input from "../StudentAuth/input";
import { ToastContainer, 
	// toast 
} from "react-toastify";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
//import { GoogleLogin } from "react-google-login";

import PasswordStrengthBar from "react-password-strength-bar";
//import { CompareArrowsOutlined } from "@material-ui/icons";

const initialState = {
	firstname: "",
	lastname: "",
	email: "",
	password: "",
	mobile: "",
	confirmPassword: "",
};

const EduRegister = () => {
	const [form, setForm] = useState(initialState);
	const [errors,
		//  setErrors
		] = useState([]);
	const classes = useStyles();
    const history = useHistory();
	// const schema = {
	// 	email: Joi.string().email({
	// 		minDomainSegments: 2,
	// 		tlds: { allow: ["com", "net"] },
	// 	}),
	// 	password: Joi.string().required().min(6).label("Password"),
	// 	confirmPassword: Joi.string().required().label("Confirm Password"),
	// 	name: Joi.string().min(3).required().label("Full Name"),
	// 	mobile: Joi.string().label("Mobile Number"),
	// };
	const handleSubmit = async (event) => {
		console.log('handle submit');	
		console.log(form);
		event.preventDefault();
		if (form.password.length >= 8 &&form.confirmPassword.length >= 8 &&	form.mobile.length === 13 ) {
			if (
			  form.password === form.confirmPassword &&
			  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
				form.email
			  )
			) {
			  fetch("https://edtechv.herokuapp.com/api/signup", {
				method: "post",
				headers: { "Content-type": "application/json" },
				body: JSON.stringify({
				  firstname: form.firstname,
				  educator: "true",
				  lastname: form.lastname,
				  email: form.email,
				  phone: form.mobile,
				  password: form.password,
				  picture:
					"https://firebasestorage.googleapis.com/v0/b/shrink4shrink.appspot.com/o/img.png?alt=media&token=9ea01296-80dd-44ad-a3e8-1442110f179b",
				}),
			  })
				.then((response) => response.json())
				.then((user) => {
				  console.log(user);
				  if (user.email) {
					//console.log(this.props);
					alert("you have successfully registered. Proceed to Sign IN!!");
					localStorage.setItem("user", JSON.stringify(user));
					//this.props.history.push("/student/login");
					history.push({
						pathname:  "/educator/login",
					});
				  } else {
					alert(user);
				  }
				});
			} else {
			  alert("Check both passwords or Email format");
			}
		  } else {
			alert("Check password length or contact number format");
		  }
	};

	const handleChange = (e) =>
		setForm({ ...form, [e.target.name]: e.target.value });

	return (
		<div>
			<ToastContainer />
			<Container component="main" className="educator-signup-main">
				<div className="edu-signup-img">
					<img src="/images/reading.png" height="454" alt=""/>
				</div>
				<div className="sign-in-form">
					<h1>Sign Up</h1>
					{errors.length !== 0 && <Alert severity="error">{errors[0]} </Alert>}
					<form className={classes.form} onSubmit={handleSubmit}>
						<Grid container spacing={2}>
							<Input
								name="firstname"
								label="First Name"
								handleChange={handleChange}
								autoFocus
								className="sign-input"
							/>
							<Input
								name="lastname"
								label="Last Name"
								handleChange={handleChange}
								autoFocus
								className="sign-input"
							/>
							<Input
								name="mobile"
								label="Mobile Number"
								handleChange={handleChange}
							/>
							<Input
								name="email"
								label="Email Address"
								handleChange={handleChange}
								type="email"
							/>
							<Input
								name="password"
								label="Password"
								handleChange={handleChange}
								type="password"
							/>
							{form.password!== ''&&<PasswordStrengthBar password={form.password} />}
							<Input
								name="confirmPassword"
								label="Confirm Password"
								handleChange={handleChange}
								type="password"
							/>
                            {/* <PasswordStrengthBar password={form.confirmPassword}/> */}
						</Grid>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={`${classes.submit} sub-sign-btn`}
						>
							Sign Up
						</Button>
						<Grid container justify="center">
							<Grid item>
								Already have an account?
								<Button href="/educator/login">
									<Link
										style={{ textDecoration: "none", fontWeight: "700" }}
										to="/student/login"
									>
										Log In
									</Link>
								</Button>
							</Grid>
						</Grid>
					</form>
				</div>
			</Container>
		</div>
	);
};

export default EduRegister;
